module.exports = __webpack_public_path__ + "static/media/yellow-hive-artwork.09a47a68.png";